<mat-spinner class="custom-spinner" [diameter]="diameter"></mat-spinner>
